import * as cn from "classnames";
import * as React from "react";
import { RowsAndColsStatus } from "./FakeComponent";
import "./Timetable.css";
import { FieldError } from "./ErrorMessage";

const mockWeek = [
    { name: "Sun", value: "Sun" },
    { name: "Mon", value: "Mon" },
    { name: "Tue", value: "Tue" },
    { name: "Wed", value: "Wed" },
    { name: "Thu", value: "Thu" },
    { name: "Fri", value: "Fri" },
    { name: "Sat", value: "Sat" }
];

const RevievTimetable = ({ RowsAndColsStatus, renderDay, weekDays }: any) => (
    <div className="table-wrapper preview">
        <div className="time-legend preview">
            <ul>
                <li>6am</li>
                <li className="time-legend-stick">|</li>
                <li>12pm</li>
                <li className="time-legend-stick">|</li>
                <li>10pm</li>
                <li className="time-legend-stick">|</li>
                <li>6am</li>
            </ul>
        </div>
        <table className="timetable preview">
            <thead>
                <tr>
                    <th
                        className="timetable_main-title-block"
                        style={{
                            textAlign: "left",
                            padding: 0,
                            margin: 0,
                            verticalAlign: "top"
                        }}
                    >
                        Time
                    </th>
                    {mockWeek.map((el, index) => {
                        return (
                            <th
                                key={index}
                                className={cn(
                                    RowsAndColsStatus && RowsAndColsStatus.colsStatus[el.value] ? "active" : ""
                                )}
                            >
                                <div className="textwrap">{el.name}</div>
                            </th>
                        );
                    })}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <div className="textwrap">Morning</div>
                    </td>
                    {renderDay(weekDays, "morning")}
                </tr>
                <tr>
                    <td>
                        <div className="textwrap">Afternoon</div>
                    </td>
                    {renderDay(weekDays, "afternoon")}
                </tr>
                <tr>
                    <td>
                        <div className="textwrap">Night</div>
                    </td>
                    {renderDay(weekDays, "night")}
                </tr>
            </tbody>
        </table>
    </div>
);

export interface TimetableDay {
    morning: boolean;
    afternoon: boolean;
    night: boolean;
}

export interface TimetableData {
    Sun: TimetableDay;
    Mon: TimetableDay;
    Tue: TimetableDay;
    Wed: TimetableDay;
    Thu: TimetableDay;
    Fri: TimetableDay;
    Sat: TimetableDay;
}

export interface TimetableComponentProps {
    value: TimetableData;
    field?: any | null;
    RowsAndColsStatus?: RowsAndColsStatus;
    isReviewComponent?: boolean;
    onChange?: (weekDay: string, dayTime: string) => void;
    onRowChange?: (dayTime: string) => void;
    onColChange?: (weekDay: string) => void;
    onChangeAll?: () => void;
}

export class TimetableComponent extends React.Component<TimetableComponentProps, any> {
    constructor(props: TimetableComponentProps) {
        super(props);
    }

    renderDay(weekDays: TimetableData, dayTime: string) {
        return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day: string, index: number) => {
            return (
                <td
                    className="cell-value"
                    key={index}
                    onClick={e => (!this.props.isReviewComponent ? this.props.onChange(day, dayTime) : "")}
                >
                    <span className={cn("table-circle-icon", weekDays[day][dayTime] ? "active" : "")} />
                </td>
            );
        });
    }

    render() {
        const weekDays = this.props.value;
        const RowsAndColsStatus = this.props.RowsAndColsStatus;
        let tableStatus: boolean[] = [];
        let resultTableStatus: boolean;

        if (RowsAndColsStatus) {
            for (let status in RowsAndColsStatus.colsStatus) {
                tableStatus.push(RowsAndColsStatus.colsStatus[status]);
            }

            for (let status in RowsAndColsStatus.rowsStatus) {
                tableStatus.push(RowsAndColsStatus.rowsStatus[status]);
            }

            resultTableStatus = tableStatus.every(status => status === true);
        }

        if (this.props.isReviewComponent) {
            return (
                <RevievTimetable RowsAndColsStatus={RowsAndColsStatus} renderDay={this.renderDay} weekDays={weekDays} />
            );
        }

        return (
            <div className="table-wrapper">
                <div className="time-legend">
                    <ul>
                        <li>6am</li>
                        <li className="time-legend-stick">|</li>
                        <li>12pm</li>
                        <li className="time-legend-stick">|</li>
                        <li>10pm</li>
                        <li className="time-legend-stick">|</li>
                        <li>6am</li>
                    </ul>
                </div>
                <table className="timetable">
                    <thead>
                        <tr>
                            <th
                                className="timetable_main-title-block"
                                style={{
                                    textAlign: "left",
                                    padding: 0,
                                    margin: 0,
                                    verticalAlign: "top"
                                }}
                            >
                                Time
                                <span
                                    className={cn(
                                        "select-all-btn",
                                        resultTableStatus && resultTableStatus ? "active" : ""
                                    )}
                                    onClick={() => this.props.onChangeAll()}
                                >
                                    <span className="inner-btn-block" />
                                </span>
                            </th>
                            {mockWeek.map((el, index) => {
                                return (
                                    <th
                                        key={index}
                                        className={cn(
                                            RowsAndColsStatus && RowsAndColsStatus.colsStatus[el.value] ? "active" : ""
                                        )}
                                    >
                                        <label
                                            className="common-checkbox custom-table-checkbox"
                                            htmlFor=""
                                            onClick={e => this.props.onColChange(el.value)}
                                        >
                                            <div className="common-checkbox-textwrap">{el.name}</div>
                                            <span className="checkmark" />
                                        </label>
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td
                                className={cn(
                                    "table-row-header",
                                    RowsAndColsStatus && RowsAndColsStatus.rowsStatus["morning"] ? "active" : ""
                                )}
                            >
                                <label
                                    className="common-checkbox custom-table-checkbox custom-table-checkbox-aside"
                                    htmlFor=""
                                    onClick={e => this.props.onRowChange("morning")}
                                >
                                    <div className="common-checkbox-textwrap">Morning</div>
                                    <span className="checkmark" />
                                </label>
                            </td>
                            {this.renderDay(weekDays, "morning")}
                        </tr>
                        <tr>
                            <td
                                className={cn(
                                    "table-row-header",
                                    RowsAndColsStatus && RowsAndColsStatus.rowsStatus["afternoon"] ? "active" : ""
                                )}
                            >
                                <label
                                    className="common-checkbox custom-table-checkbox custom-table-checkbox-aside"
                                    htmlFor=""
                                    onClick={e => this.props.onRowChange("afternoon")}
                                >
                                    <div className="common-checkbox-textwrap">Afternoon</div>
                                    <span className="checkmark" />
                                </label>
                            </td>
                            {this.renderDay(weekDays, "afternoon")}
                        </tr>
                        <tr>
                            <td
                                className={cn(
                                    "table-row-header",
                                    RowsAndColsStatus && RowsAndColsStatus.rowsStatus["night"] ? "active" : ""
                                )}
                            >
                                <label
                                    className="common-checkbox custom-table-checkbox custom-table-checkbox-aside"
                                    htmlFor=""
                                    onClick={e => this.props.onRowChange("night")}
                                >
                                    <div className="common-checkbox-textwrap">Night</div>
                                    <span className="checkmark" />
                                </label>
                            </td>
                            {this.renderDay(weekDays, "night")}
                        </tr>
                    </tbody>
                </table>
                <FieldError field={this.props.field} />
            </div>
        );
    }
}
